import { useEffect, useState } from "react";
import {
  Close,
  SideBarDispatchIcon,
  UpdateIcon2,
} from "../../components/icons/Icon";
import { CloseIcon } from "../../components/icons/Icon2";
import Button from "../../components/updatedComponents/Dealers/Button";
import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
import FileUpload from "../../components/updatedComponents/OrderManager/FileUpload";
import styles from "../dashboard/Dispatch.module.css";
import { handleFileData } from "../../APIsControll/apiControl2";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import VerticalDropDown2 from "../../components/updatedComponents/FormComponents/VerticalDropDown2";
import fetchData from "../../APIsControll/apiControll";

const ProdAndSaleDeliveryDetailsModal = ({
  mode,
  closeModal,
  managerId,
  orderId,
  orderData,
  partners,
  getData,
  type = "create",
  paymentLink,
  filteredShippingInfo,
  warehouseName,
  warehouseId,
  allPartners,
}) => {
  const { show } = useToast();

  const [selectedPartner, setSelectedPartner] = useState();
  const [selectedPartnerDetails, setSelectedPartnerDetails] = useState({});

  const [slip, setSlip] = useState(filteredShippingInfo[0]?.courierSlip);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (filteredShippingInfo[0]?.delPerMobile === null) {
      setSelectedPartner({
        label: filteredShippingInfo[0]?.partnerName,
        value: filteredShippingInfo[0]?.partnerName,
      });
    } else {
      setSelectedPartner({
        label: filteredShippingInfo[0]?.delPerName,
        value: filteredShippingInfo[0]?.delPerMobile,
      });
      const foundPartner = allPartners?.find(
        (p) => p?.contactNumber === filteredShippingInfo[0]?.delPerMobile,
      );
      setSelectedPartnerDetails(foundPartner || null);
    }
    if (filteredShippingInfo[0]?.methodName !== "E-rickshaw") {
      setSelectedPartnerDetails((prev) => ({
        ...prev,
        partnerName: filteredShippingInfo[0]?.partnerName,
      }));
    }
  }, [filteredShippingInfo, allPartners, type]);

  const sendMessage = async (apiData) => {
    try {
      const res = await fetchData("wallikonChat/sentStatusTemp", apiData);
      if (res.status === "success") {
        getData();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const sendCourierSlipTemplate = async (slip) => {
    const phoneNumber = orderData.whatsapp
      ? orderData.whatsapp
      : orderData.mobile
        ? orderData.mobile
        : "";
    const formData = new FormData();
    formData.append("loginId", managerId);
    formData.append("phoneNumber", phoneNumber);
    formData.append("templateName", "receipt_link");
    formData.append("headerType", "image");
    formData.append("dealerName", orderData?.shippingAddress?.name);
    formData.append("orderId", orderId);
    formData.append("file", slip);
    try {
      await handleFileData("deliveryPartner/courierSlipTemp", formData);
    } catch (error) {}
  };

  const dispatchOrder = async () => {
    const isSelf = selectedPartner.label === "Self";
    if (selectedPartner?.value === 0 || selectedPartner.value === "") {
      show("Please select a partner!", "warning");
      return;
    }
    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/svg+xml",
    ];
    if (slip && !allowedTypes.includes(slip.type)) {
      show(
        "Invalid image format. Only PNG, JPEG, JPG, or SVG are allowed.",
        "error",
      );
      return;
    }

    const formData = new FormData();

    formData.append("managerId", managerId);
    formData.append("voucherId", orderId);

    // formData.append("shippingType", orderData?.shippingType || "");
    formData.append(
      "courierName",
      isSelf ? "Self" : filteredShippingInfo[0]?.courierName || "",
    );
    formData.append(
      "methodName",
      isSelf ? "Self" : filteredShippingInfo[0]?.methodName || "",
    );
    formData.append(
      "partnerName",
      isSelf ? "Self" : selectedPartnerDetails?.partnerName || "",
    );
    formData.append("delPerName", selectedPartnerDetails?.partnerName || "");
    formData.append(
      "delPerMobile",
      selectedPartnerDetails?.contactNumber || "",
    );
    formData.append(
      "delTrackingNo",
      selectedPartnerDetails?.delTrackingNo || "",
    );
    formData.append(
      "delTrackingUrl",
      selectedPartnerDetails?.trackingUrl || "",
    );
    formData.append("image", slip);
    // formData.append("warehouseId", warehouseId);
    // formData.append("warehousename", warehouseName);

    const phoneNumber = orderData.whatsapp
      ? orderData.whatsapp
      : orderData.mobile
        ? orderData.mobile
        : "";

    const apiData1 = {
      managerId: managerId,
      phoneNumber: phoneNumber,
      templateName: "online_order_dispatched",
      headerId: "https://dealer.wallicon.in/assets/dispatched.jpg",
      buttonDataPayload: paymentLink,
    };

    try {
      setLoading(true);

      const res = await handleFileData(
        `dispatch/prodAndSaleDeliveryDetails`,
        formData,
      );

      if (res.status === "success") {
        // if (slip) {
        //   await sendCourierSlipTemplate(slip);
        // } else {
        //   await sendMessage(apiData1);
        // }
        await sendMessage(apiData1);
        show(res.msg, "success");

        getData();

        closeModal();

        setLoading(false);
      }

      if (res.status === "failed") {
        setLoading(false);
        show(res.msg, "error");
      }

      if (res.status === "warn") {
        setLoading(false);
        show(res.msg, "error");
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const btnIcon =
    type === "update" ? (
      <UpdateIcon2 />
    ) : (
      <SideBarDispatchIcon color="#FFFFFF" />
    );

  const btnText = type === "update" ? "Update" : "Dispatch";

  return (
    <div
      className={styles.pack_order_modal}
      style={{ backgroundColor: mode && "#232529", width: "600px" }}
    >
      <div className={styles.header}>
        <p style={{ color: mode && "#FFFFFF" }}>Dispatch Order</p>
        <div onClick={closeModal}>
          <CloseIcon mode={mode} />
        </div>
      </div>

      <div className={styles.sec}>
        <InputTag
          name="method"
          value={filteredShippingInfo[0]?.courierName}
          labelText={"Method"}
          readOnly={true}
          star
          padding={"8px"}
          fontSize={"12px"}
        />
        <InputTag
          name="subMethod"
          value={filteredShippingInfo[0]?.methodName}
          labelText={"Sub Method"}
          readOnly={true}
          star
          padding={"8px"}
          fontSize={"12px"}
        />
        <VerticalDropDown2
          options={partners?.map((p) => ({
            label: p?.partnerName,
            value: p?.contactNumber,
          }))}
          label={"Select Partner"}
          star
          value={selectedPartner}
          onchange={(v) => {
            setSelectedPartner(v);
            const foundPartner = partners?.find(
              (p) => p?.contactNumber === v?.value,
            );
            setSelectedPartnerDetails(foundPartner || null);
          }}
          height={"37px"}
          fontSize={"12px"}
        />
      </div>

      <div className={styles.sec}>
        <InputTag
          name="partnerName"
          value={
            selectedPartner?.label === "Self"
              ? "Self"
              : selectedPartnerDetails?.partnerName
          }
          labelText={"Partner Name"}
          readOnly={true}
          star
          padding={"8px"}
          fontSize={"12px"}
        />
        <InputTag
          name="partnerNumber"
          value={selectedPartnerDetails?.contactNumber}
          labelText={"Partner Number"}
          readOnly={true}
          star
          padding={"8px"}
          fontSize={"12px"}
        />
      </div>

      <div className={styles.sec}>
        <InputTag
          name="trackingNumber"
          value={selectedPartnerDetails?.trackingNumber}
          labelText={"Tracking Number"}
          readOnly={true}
          padding={"8px"}
          fontSize={"12px"}
        />
        <InputTag
          name="trackingURL"
          value={selectedPartnerDetails?.trackingUrl}
          labelText={"Tracking URL"}
          readOnly={true}
          padding={"8px"}
          fontSize={"12px"}
        />
      </div>

      <div className={styles.upload_del_slip}>
        <p style={{ color: mode && "#FFFFFF" }}>Delivery Slip</p>
        <FileUpload
          mode={mode}
          image={slip}
          setImage={setSlip}
          onFileChange={(file) => setSlip(file)}
        />
      </div>

      <div
        className={styles.bottom_btns}
        style={{ marginTop: slip ? "10px" : undefined }}
      >
        <Button
          buttonBgColor={"#000000"}
          buttonTextColor={"#FFFFFF"}
          buttonText={"Close"}
          buttonIcon={<Close />}
          buttonClick={closeModal}
        />
        <Button
          buttonBgColor={"#4164E3"}
          buttonTextColor={"#FFFFFF"}
          buttonText={btnText}
          buttonIcon={btnIcon}
          buttonClick={dispatchOrder}
          loading={loading}
          disabled={loading}
        />
      </div>
    </div>
  );
};

export default ProdAndSaleDeliveryDetailsModal;
